/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiCampaignsCampaignStatusItem =
    (typeof GetApiCampaignsCampaignStatusItem)[keyof typeof GetApiCampaignsCampaignStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiCampaignsCampaignStatusItem = {
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    TRIGGERED: 'TRIGGERED',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    PAUSED: 'PAUSED',
    CANCELLED: 'CANCELLED',
} as const;
